var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3287.47 1607.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#56C75E",
    d: "M-0 1607.2l3287.47 0 0 -1607.2c-145.46,76.97 -249.05,117.16 -405.57,178.86 -368.01,145.09 -665.7,378.95 -971.14,563.01 -99.12,59.74 -119.86,90.95 -195.02,133.74 -109.12,62.11 -314.08,97.57 -474.68,109.75 -318.12,24.13 -685.09,134.27 -918.56,323.38 -64.83,52.5 -287.94,246.88 -322.49,298.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonitor);
export default __webpack_public_path__ + "static/media/iconMonitor.07c663151465b536c9da6b31cea95be3.svg";
export { ForwardRef as ReactComponent };